export const en = {
    title: `Forgot Password`,
    description: `Enter your email address and we'll send you reset instructions`,
    success: `Check your email for reset instructions`,
    sendInstructions: `Send Reset Instructions`,
    failure: `Failed to send reset email`,
};
//# sourceMappingURL=en.js.map